import { BaseQueryBuilder } from './BaseQueryBuilder';
import { DetailsRequest } from './DetailsRequest';
import { DetailsResponseResponseBuilder } from './DetailsResponseResponseBuilder';

export class DetailsQueryBuilder extends BaseQueryBuilder {
    constructor(responseBuilder: DetailsResponseResponseBuilder, detailsRequest: DetailsRequest) {
        super('details', responseBuilder);
        if (detailsRequest) this.args.push(this.addVariable('DetailsRequest', 'DetailsRequest', true, detailsRequest));
    }
}
